import { cn } from "@/lib/utils";

export function SectionTitle({
  children,
  className,
  align = "left",
  light = false,
}: {
  children: React.ReactNode;
  className?: string;
  align?: "left" | "center";
  light?: boolean;
}) {
  return (
    <h2
      className={cn(
        "font-display text-3xl md:text-5xl leading-[1.05]",
        align === "center" && "text-center",
        light ? "text-white" : "text-brand-charcoal",
        className
      )}
    >
      {children}
    </h2>
  );
}
